let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lG5pw")).then(() => parcelRequire('4oP0D'));